// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1quvK","sendOtp":"AuthorizeToLogin_sendOtp__3JR-t"};